<template>
  <main class="container">
    <div class="bg-light p-5 rounded mt-3">
      <h2>请勿使用微信浏览</h2>
      <p class="lead">请复制网址到外部浏览器访问！！！</p>
      <button class="btn btn-lg btn-primary" role="button" @click="copy(url)">复制网址</button>
    </div>
  </main>

  <!-- Bootstrap Toast 通知 -->
  <div class="position-fixed top-0 end-0 p-3" style="z-index: 11">
    <div id="liveToast" aria-atomic="true" aria-live="assertive" class="toast" role="alert">
      <div class="d-flex">
        <div class="toast-body"></div>
        <button aria-label="Close" class="btn-close me-2 m-auto" data-bs-dismiss="toast" type="button"></button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {copy} from "@/utils/Toast";

const url = ref(window.location.href);

onMounted(() => {
  const forms = document.querySelectorAll('.needs-validation')
  Array.from(forms).forEach(form => {
    form.addEventListener('submit', event => {
      event.preventDefault()
      event.stopPropagation()
      form.classList.add('was-validated')
    }, false);
  })
});

</script>

<style scoped>
</style>